import * as React from 'react';

export const BigPremiumIcon = (id: number | string, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id={`premium-grad-${id}`} x1="50.022%" x2="50.022%" y1="99.942%" y2=".283%">
        <stop offset="0%" stopColor="#FF5050" />
        <stop offset="54.2%" stopColor="#FF7B0D" />
        <stop offset="100%" stopColor="#FF8400" />
      </linearGradient>
      <linearGradient id={`premium-grad-b-${id}`} x1="50.052%" x2="50.052%" y1="100.027%" y2=".001%">
        <stop offset="0%" stopColor="#FF5050" />
        <stop offset="54.2%" stopColor="#FF7B0D" />
        <stop offset="100%" stopColor="#FF8400" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <path
        d="M3.527 29.132c-.515.427-1.124 1.133-1.676 2.24-.69 1.404-.73 2.34-.68 2.81.02.14.2.206.29.105 1.07-1.197 1.83-1.018 1.44-.114-.16.36-.55.865-1.11 1.404-.93.898-1.59 2.11-1.71 3.49-.01.13-.02.26-.02.39v.058c0 .218.02.44.06.66.02.138.2.196.28.098.57-.657 2.41-2.36 6.27-2.764 3.54-.42 4.46-2.49 4.66-3.1.38-1.17.28-2.19-.01-2.99-.054-.16-.282-.16-.31-.01-.155.85-.68 2.02-2.33 2.57-2.754.92-4.263 1.31-4.263 1.31s.83-1.38 1.035-3.12c.2-1.68.987-3.26 2.66-3.58.16-.03.16-.25 0-.31-.535-.2-1.102-.3-1.674-.31-.915 0-1.93.282-2.93 1.13"
        fill={`url(#premium-grad-${id})`}
        transform="translate(0 -1)"
      />
      <path
        d="M38.896 1.328c-.21-.21-.714-.32-1.426-.33h-.16c-3.35.036-10.84 2.142-15.15 6.452C16.82 12.787 12 20.357 12 20.357l-8.3-.237a.471.471 0 0 0-.32.108l-2.11 1.68c-.12.1-.19.246-.19.39 0 .185.1.354.27.44l5.02 2.72c.05.026.1.044.16.053l3.33.55c.12.02.23.08.3.17l.64.74 1.24 1.25 1.25 1.24.74.64c.09.08.15.19.17.3l.548 3.33c.01.06.028.11.054.16l2.72 5.02a.495.495 0 0 0 .83.08l1.678-2.11c.075-.09.11-.21.11-.32l-.24-8.3s7.57-4.82 12.91-10.16c5.34-5.335 7.3-15.562 6.12-16.74l-.034-.03v-.003zm-9.85 13.28c-.785.776-1.64 1.142-2.428 1.142-.58 0-1.12-.2-1.57-.577-.9-1.052-.79-2.632.56-3.994 1.36-1.38 2.72-1.27 3.74-.32.94 1.02 1.06 2.38-.32 3.74l.018.005v.004z"
        fill={`url(#premium-grad-b-${id})`}
        transform="translate(0 -1)"
      />
    </g>
  </svg>
);
